import React from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { useDebouncedResize } from "~/my-account/Common/myAccountHooks";
import { useFeatureFlag } from "~/common/contexts/FeatureFlagProvider";
import MediaReviewThumbnail from "../MediaReviewThumbnail";
import { MediaIdentifier, MediaReview } from "../../reviewModels";
import { cls } from "@wss/cls";
const getMediaLimit = (width: number) => {
  const getScreenSizeCategory = (width: number) => {
    // Limiting per design to breakpoint when thumbnail section moves to sidebar
    if (width > 945) return "desktop";
    if (width > 599) return "tablet";
    return "mobile";
  };
  const screenSizeCategory = getScreenSizeCategory(width);
  const isTablet = screenSizeCategory === "tablet";
  const isMobile = screenSizeCategory === "mobile";
  if (isTablet) {
    return 8;
  } else if (isMobile) {
    return 4;
  }
  return 16;
};
export interface UserPhotosAndVideosProps {
  mediaReviews: Array<MediaReview>;
  handleSelectMediaElement: (newMedia: MediaIdentifier | undefined) => void;
  isProductReviewPage?: boolean;
}
const UserPhotosAndVideos = ({
  mediaReviews,
  handleSelectMediaElement,
  isProductReviewPage = false
}: UserPhotosAndVideosProps) => {
  const {
    width
  } = useDebouncedResize();
  const {
    evaluateFlag
  } = useFeatureFlag();
  const filterByRatingEnabled = evaluateFlag("filter-by-rating");
  const mediaLimit = filterByRatingEnabled ? getMediaLimit(width) : 16;
  return <div className={cls("box padded user-uploaded-photo-grid", {
    "lt:mt-16": isProductReviewPage,
    "!my-5 lt:!my-0": !isProductReviewPage && filterByRatingEnabled
  })} data-sentry-component="UserPhotosAndVideos" data-sentry-source-file="index.tsx">
      <div className={cls("flex", "justify-between", "items-start")}>
        <h4 className={`${isProductReviewPage ? "" : "lt:text-lg xl:text-xl"} text-xl text-semibold leading-6`}>
          Customer Photos &amp; Videos
        </h4>
        {mediaReviews.length > mediaLimit ? <Modal.Trigger theme="headless" htmlFor="zest-modal-button" className="bg-transparent shadow-none whitespace-nowrap" data-testid="see-all-media-reviews" onClick={() => {
        handleSelectMediaElement({
          // non-null assertion is safe because we know there is at least one media review for this component to be rendered
          id: mediaReviews[0]!.id,
          type: mediaReviews[0]!.type
        });
      }} type="button" aria-label="See all media reviews" CustomTrigger={<span className={cls("text-green-500", "underline", "font-semibold", "text-sm", "decoration-1")}>
                See all
              </span>} /> : null}
      </div>
      <div className={cls("thumbs thumbs--bg-cover", {
      "flex lt:block": filterByRatingEnabled
    })} data-testid="user-review-photos-and-videos">
        {mediaReviews.slice(0, mediaLimit).map((mediaReview, index) => <MediaReviewThumbnail key={index} isProductReviewPage={isProductReviewPage} truncate={mediaLimit === index + 1} totalRemainingMediaReviews={mediaReviews.length - mediaLimit} productReviewIndex={index} mediaReview={mediaReview} setSelectedModalMedia={() => {
        handleSelectMediaElement({
          id: mediaReview.id,
          type: mediaReview.type
        });
      }} iconClassName={cls("absolute", "fill-current", "text-white")} />)}
      </div>
    </div>;
};
export default UserPhotosAndVideos;